export const PAGE_SIZE = 10

function calcPageOffset(page: number, offset: number) {
  return page * offset
}

type PaginationParams = {
  limit: number
  offset: number
}

function defaultPaginationParams(pageParam = 0) {
  return {
    limit: PAGE_SIZE,
    offset: calcPageOffset(pageParam, PAGE_SIZE),
  }
}

function infiniteQueryNextPageParam<T>(
  lastPage: T extends { totalCount: number } ? T : never,
  allPages: Array<T extends { totalCount: number } ? T : never>
) {
  const nextPage = allPages.length
  return calcPageOffset(nextPage, PAGE_SIZE) < lastPage.totalCount
    ? nextPage
    : undefined
}

export {
  type PaginationParams,
  defaultPaginationParams,
  infiniteQueryNextPageParam,
}
